import moment from 'moment'
import { EventEmitter } from 'events'
import { Base_Dispatcher } from '../../zap/Base/Base.Dispatcher'
import type { Type_ILocation, Type_ILocationFocusList } from '../../zap/Type/Type.hive'
import {
    Plan_SET_DATE,
    Plan_SET_EVENT_FOCUSLIST,
    Plan_SET_LOCATION,
    Plan_SET_NEXT_DATE,
    Plan_SET_PREVIOUS_DATE,
    Plan_SET_ROUTE,
    Plan_SET_ROUTELOCATIONS,
} from '../../zap/Plan/Plan.constants'

const CHANGE_EVENT = 'change'
let _date: Date = new Date()
let _routeLocations: number[] = []
let _route: any = []
let _selectedLocation: Type_ILocation
let _eventFocusList: Type_ILocationFocusList

class PlannerStore extends EventEmitter {
    public setDate(date: Date) {
        _date = date
    }

    public setDateChange(change: any) {
        _date = moment(_date).add(change, 'day').toDate()
    }

    public getDate() {
        return _date
    }

    public setRouteLocations(routeLocations: number[]) {
        _routeLocations = routeLocations
    }

    public getRouteLocations() {
        return _routeLocations
    }

    public setRoute(route: any) {
        _route = route
    }

    public getRoute() {
        return _route
    }

    public setLocation(location: Type_ILocation) {
        _selectedLocation = location
    }

    public getLocation() {
        return _selectedLocation
    }

    public setEventFocusList(focuslist: Type_ILocationFocusList) {
        _eventFocusList = focuslist
    }

    public getEventFocusList() {
        return _eventFocusList
    }

    public deleteStoreData() {
        _date = new Date()
        _routeLocations = []
        _route = []
    }

    public emitChange() {
        this.emit(CHANGE_EVENT)
    }

    public addChangeListener(callback: any) {
        this.on(CHANGE_EVENT, callback)
    }

    public removeChangeListener(callback: any) {
        this.removeListener(CHANGE_EVENT, callback)
    }
}

const store = new PlannerStore()

// Register callback to handle all updates
Base_Dispatcher.register(function (action: any) {
    if (action.actionType === undefined) {
        throw Error('Attempting to dispatch an undefined action to Planner store. Please check your constants.')
    }

    switch (action.actionType) {
        case Plan_SET_DATE:
            store.setDate(action.data)
            store.emitChange()
            break
        case Plan_SET_NEXT_DATE:
            store.setDateChange(1)
            store.emitChange()
            break
        case Plan_SET_PREVIOUS_DATE:
            store.setDateChange(-1)
            store.emitChange()
            break

        case Plan_SET_ROUTELOCATIONS:
            store.setRouteLocations(action.data)
            store.emitChange()
            break

        case Plan_SET_ROUTE:
            store.setRoute(action.data)
            store.emitChange()
            break

        case Plan_SET_LOCATION:
            store.setLocation(action.data)
            store.emitChange()
            break

        case Plan_SET_EVENT_FOCUSLIST:
            store.setEventFocusList(action.data)
            store.emitChange()
            break

        default:
            return true
    }
})

export default store
